import axios from 'axios';
import connAxios from "./Conn"

//const USER_API_BASE_URL = 'http://localhost:8080';
const USER_API_BASE_URL = process.env.REACT_APP_API_ENDPOINT + '/employee';
const USER_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

let config = {
    headers: {
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin': '*',
      }
}

class Employee {

    fetchEmployees() {
        return connAxios.get(USER_API_BASE_URL+'/listAll');
    }

    fetchTypeEmployees() {
        return connAxios.get(USER_BASE_URL+'/employee-type/listAll');
    }   

    fetchEmployeeById(empId) {
        return connAxios.get(USER_API_BASE_URL + '/' + empId);
    }

    fecthEmployeeByType(type){
        return connAxios.get(USER_API_BASE_URL + '/' + type);
    }

    deleteEmployee(emp) {
        return connAxios.delete(USER_API_BASE_URL + '/delete', emp);
    }

    addEmployee(emp) {
        return connAxios.post(USER_API_BASE_URL+'/add', emp, config);
    }

    editEmployee(emp) {
        return connAxios.put(USER_API_BASE_URL + '/update', emp);
    }

}

export default new Employee();